export default "__VITE_ASSET__86cb3ba6__"